var map = {
	"./404/404-page.vue": [
		1445,
		445
	],
	"./activate-account/activate-account-page.vue": [
		5232,
		232
	],
	"./bookstore/bookstore-page.vue": [
		3179,
		179
	],
	"./channel/channel-page.vue": [
		9972,
		972
	],
	"./channels/channels-page.vue": [
		8785,
		785
	],
	"./dashboard/dashboard-page.vue": [
		3504,
		504
	],
	"./forgot-password/forgot-password-page.vue": [
		2411,
		411
	],
	"./login/login-page.vue": [
		4845,
		845
	],
	"./magazine/magazine-page.vue": [
		2346,
		346
	],
	"./magazines/magazines-page.vue": [
		7786,
		786
	],
	"./orders/orders-page.vue": [
		2242,
		242
	],
	"./payment/payment-page.vue": [
		1348,
		348
	],
	"./reset-password/reset-password-page.vue": [
		7546,
		546
	],
	"./settings/settings-page.vue": [
		367,
		367
	],
	"./shipping-zones/shipping-zones-page.vue": [
		1050,
		50
	],
	"./staff/staff-page.vue": [
		5649,
		649
	],
	"./subscribers/subscribers-page.vue": [
		3661,
		661
	],
	"./verify-email/verify-email-page.vue": [
		2717,
		553
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5297;
module.exports = webpackAsyncContext;